// Public messages only. Never copy database or response text into these errors.
const financialWriteErrors = [
  { status: 400, code: 'INVALID_FINANCIAL_PERIOD_ID', error: 'A valid financial period ID is required.' },
  { status: 404, code: 'FINANCIAL_PERIOD_NOT_FOUND', error: 'Financial period not found' },
  { status: 500, code: 'RATIO_CALCULATION_FAILED', error: 'Ratios could not be calculated.' },
  { status: 500, code: 'PERIOD_LOCK_FAILED', error: 'The period could not be locked. No changes were saved.' },
] as const;

export function financialWriteError(status: unknown, code: unknown) {
  const match = financialWriteErrors.find(item => item.status === status && item.code === code);
  return match ? { code: match.code, error: match.error } : undefined;
}
